import DriveCard from './DriveCard';

export default DriveCard;



// WEBPACK FOOTER //
// ./src/components/DriveCard/index.js